<template>
    <v-dialog :value="value" max-width="480" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="d-flex align-start">
                <div style="min-width: 0;">
                    <div class="text-subtitle-1 font-weight-bold">{{ title }}</div>
                    <div class="text-caption grey--text">{{ subtitle }}</div>
                </div>
                <v-spacer />
                <v-btn icon small @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-btn v-if="leave" small outlined color="primary" class="text-none mb-3" @click="$emit('open-request', leave)">
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Open leave request
                </v-btn>

                <div v-if="!notes.length" class="grey--text text-body-2 mb-3">No notes for this day yet.</div>
                <div v-for="n in notes" :key="n.id" class="note-item mb-3">
                    <div class="d-flex align-center">
                        <span class="text-caption font-weight-bold">{{ (n.author && n.author.name) || 'Manager' }}</span>
                        <v-chip v-if="n.is_private" x-small label outlined color="deep-purple" class="ml-2" title="Added with the leave. Only managers see it, not the employee.">
                            <v-icon x-small left>mdi-eye-off-outline</v-icon>Private
                        </v-chip>
                        <span class="text-caption grey--text ml-2">{{ formatTime(n.created_at) }}</span>
                        <v-spacer />
                        <template v-if="canChange(n) && editingId !== n.id">
                            <v-btn icon x-small @click="startEdit(n)"><v-icon small>mdi-pencil</v-icon></v-btn>
                            <v-btn icon x-small :disabled="busy" @click="$emit('remove', n.id)"><v-icon small color="error">mdi-delete</v-icon></v-btn>
                        </template>
                    </div>
                    <div v-if="editingId !== n.id" class="text-body-2" style="white-space: pre-wrap;">{{ n.body }}</div>
                    <div v-else>
                        <v-textarea v-model="editText" outlined dense rows="2" counter="1000" hide-details="auto" class="mt-1" />
                        <div class="d-flex justify-end mt-1" style="gap: 6px;">
                            <v-btn small text class="text-none" @click="editingId = null">Cancel</v-btn>
                            <v-btn small color="primary" class="text-none" :loading="busy" :disabled="!editText.trim()" @click="saveEdit(n)">Save</v-btn>
                        </div>
                    </div>
                </div>

                <v-textarea v-model="draft" outlined dense rows="2" counter="1000" placeholder="Add a note…" hide-details="auto" />
            </v-card-text>

            <v-card-actions class="px-6 pb-4">
                <v-spacer />
                <v-btn color="primary" class="text-none" :loading="busy" :disabled="!draft.trim() || draft.length > 1000" @click="$emit('add', draft.trim())">
                    Add note
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'LeaveNoteDialog',
    props: {
        value: { type: Boolean, default: false },
        title: { type: String, default: '' },
        subtitle: { type: String, default: '' },
        notes: { type: Array, default: () => [] },
        currentUserId: { type: Number, default: null },
        isSuperAdmin: { type: Boolean, default: false },
        busy: { type: Boolean, default: false },
        leave: { type: Object, default: null },
    },
    data() {
        return { draft: '', editingId: null, editText: '' };
    },
    watch: {
        value(open) {
            if (open) {
                this.draft = '';
                this.editingId = null;
            }
        },
    },
    methods: {
        canChange(n) {
            return this.isSuperAdmin || Number(n.author_id) === this.currentUserId;
        },
        startEdit(n) {
            this.editingId = n.id;
            this.editText = n.body;
        },
        saveEdit(n) {
            this.$emit('edit', { id: n.id, body: this.editText.trim() });
        },
        formatTime(s) {
            return s ? this.$date(s).format('MMM D, h:mm A') : '';
        },
        // The panel calls these after a successful API call
        clearDraft() {
            this.draft = '';
        },
        stopEditing() {
            this.editingId = null;
        },
    },
};
</script>

<style scoped>
.note-item {
    padding: 8px 10px;
    border: 1px solid #eee;
    border-radius: 6px;
    background: #fafafa;
}
</style>
